// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3HOKt","emails":"CreateEditClinics_emails__3xivP","emailTagLabel":"CreateEditClinics_emailTagLabel__3rjNa"};